import { Icon } from '@frontend/icons';
import { PopoverMenu, PopoverMenuItem, Text, usePopoverMenu } from '@frontend/design-system';
import { StatusChip } from '../status-chip';
import { ActiveStatusChipProps } from './types';
import { useGetAppointmentStatusList } from './use-get-appointment-status-list';
import { Wrapper } from './wrapper';

export const ActiveStatusChip = ({
  appointmentDetails,
  isIntegrated,
  darkModeMenu,
  wrapperStyle,
  onStatusChange,
  ...restProps
}: ActiveStatusChipProps) => {
  const popoverMenu = usePopoverMenu({ placement: 'bottom-start', darkMode: darkModeMenu });
  const popoverMenuTriggerProps = popoverMenu.getTriggerProps({ allowPropagation: false });
  const appointmentStatusList = useGetAppointmentStatusList({ isIntegrated, appointmentDetails });

  return (
    <>
      <Wrapper wrapperStyle={wrapperStyle} {...popoverMenuTriggerProps}>
        <StatusChip {...restProps} {...popoverMenuTriggerProps} />
      </Wrapper>
      <PopoverMenu {...popoverMenu.getMenuProps()}>
        {appointmentStatusList.map((item, index) => (
          <PopoverMenuItem
            {...popoverMenu.getItemProps({ index, onClick: () => onStatusChange?.(item) })}
            key={item.key}
            value={item.value}
            active={item.key === restProps.status}
          >
            <Icon name={item.icon} />
            <Text as='span'>
              {isIntegrated && item.key ? `${item.key.toLowerCase().replaceAll('_', ' ')} / ${item.label}` : item.label}
            </Text>
          </PopoverMenuItem>
        ))}
      </PopoverMenu>
    </>
  );
};
